import { Injectable, inject } from '@angular/core';
import type { Data, PreloadingStrategy, Route } from '@angular/router';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import {
    ROUTE_PRELOAD_DATA_KEY,
    ROUTE_PRELOAD_KEY_DATA_KEY,
    RoutePreloadMode,
} from './models';
import { RoutePreloadIntentService } from './route-preload-intent.service';

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
    //#region Dependency injection
    private readonly preloadIntent = inject(RoutePreloadIntentService);
    //#endregion

    //#region PreloadingStrategy implementation
    preload(
        route: Route,
        load: () => Observable<unknown>
    ): Observable<unknown> {
        return this.shouldPreload(route.data) ? load() : of(null);
    }
    //#endregion

    //#region Private methods
    private shouldPreload(data: Data | undefined): boolean {
        const preloadMode = data?.[ROUTE_PRELOAD_DATA_KEY];
        if (preloadMode === true || preloadMode === RoutePreloadMode.Eager) {
            return true;
        }

        if (preloadMode !== RoutePreloadMode.Intent) {
            return false;
        }

        const preloadKey = data?.[ROUTE_PRELOAD_KEY_DATA_KEY];
        return (
            typeof preloadKey === 'string' &&
            this.preloadIntent.hasRequested(preloadKey)
        );
    }
    //#endregion
}
